
export interface PolygonStyle {
  fillColor: string,
  fillOpacity?: number,
  stokeOpacity?: number,
  strokeWeight?: number,
  strokeColor: string,
};

export interface PolygonMouseEvents {
  onMouseOver?: (e: any /* google.maps.PolyMouseEvent */) => void,
  onMouseOut?: (e: any /* google.maps.PolyMouseEvent */) => void,
  onClick?: (e: any /* google.maps.PolyMouseEvent */) => void,
};

export interface MapPolygonProps<T = object> extends PolygonStyle, PolygonMouseEvents {
  id: string, // used for the key on the react object
  path?: number[][],
  paths?: number[][][],
  zIndex?: number,
  meta?: T,
};

export interface BoundaryData<T = object> {
  /** Id used for react rendering, needs to be unique per every polygon rendered */
  id: string,
  pathJson: string,
  zIndex?: number,
  style: PolygonStyle,
  mouseEvents?: PolygonMouseEvents,
  meta?: T,
};

interface BoundaryDataExtended<T> extends BoundaryData<T> {
  pathParsed: {
    type: "Polygon" | "MultiPolygon",
    coordinates: number[][][] | number [][][][],
  },
};

export const mapArrayOfPolygonsV2 = <T = object>(boundaryArrayParam: BoundaryData<T>[]) => {
  const arrayToLatLng = c => c.map(pos => ({ lat: pos[1], lng: pos[0] }));

  let boundaryArray = boundaryArrayParam as BoundaryDataExtended<T>[];

  boundaryArray.forEach(ba => ba.pathParsed = JSON.parse(ba.pathJson));

  return boundaryArray.map(b => {
    let poly: MapPolygonProps<T> = {
      id: b.id,
      zIndex: b.zIndex,
      ...b.style,
      ...b.mouseEvents,
      meta: b.meta,
    };

    if (b.pathParsed.type === "Polygon") {
      poly.paths = b.pathParsed.coordinates.map(arrayToLatLng);
    } else {
      poly.paths = b.pathParsed.coordinates.flatMap(arr => arr.map(arrayToLatLng));
    }

    return poly;
  });
};
